import {assertAndContinue} from 'Asserts';
import {RowData} from 'notebook/tables/constants/RowConstants';
import {ColumnConstraint, TableColumnType} from 'notebook/tables/constants/TableColumnConstants';

function getColumnConstraintWithRowData(
  baseConstraint: ColumnConstraint | null,
  rowData: RowData | null
): ColumnConstraint | null {
  if (baseConstraint?.columnDefinition?.type === TableColumnType.ROW_DELEGATE) {
    const visibleColumnId = baseConstraint.structuredTableColumn?.provenanceUuid;
    const overrideConstraint =
      visibleColumnId == null ? null : (rowData?.delegatedColumnConstraints?.get(visibleColumnId) ?? null);
    if (overrideConstraint == null) {
      assertAndContinue(false, 'No column constraint found for cell in delegated column');
      return null;
    }
    return overrideConstraint;
  }
  return baseConstraint;
}

export default getColumnConstraintWithRowData;
